import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function Topbar() {
  const { userName, role, logout } = useAuth();
  const RC = { admin:'#D85A30', manager:'#378ADD', cashier:'#1D9E75', kitchen:'#854F0B' };
  return (
    <div style={{ background:'#fff', borderBottom:'1px solid #eee', padding:'10px 22px',
                  display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0 }}>
      <div style={{ display:'flex', gap:8 }}>
        <span style={{ fontSize:12, padding:'3px 9px', borderRadius:20, background:'#EAF3DE', color:'#3B6D11', fontWeight:500 }}>✅ Zomato</span>
        <span style={{ fontSize:12, padding:'3px 9px', borderRadius:20, background:'#EAF3DE', color:'#3B6D11', fontWeight:500 }}>✅ Swiggy</span>
        <span style={{ fontSize:12, padding:'3px 9px', borderRadius:20, background:'#EAF3DE', color:'#3B6D11', fontWeight:500 }}>💬 WhatsApp</span>
        <span style={{ fontSize:12, padding:'3px 9px', borderRadius:20, background:'#E6F1FB', color:'#185FA5', fontWeight:500 }}>🌐 vippizza.in</span>
      </div>
      <div style={{ display:'flex', alignItems:'center', gap:12 }}>
        <span style={{ fontSize:13 }}>👤 <b>{userName}</b></span>
        <span style={{ fontSize:11, padding:'2px 9px', borderRadius:20, background: RC[role]||'#eee', color:'#fff', fontWeight:500, textTransform:'capitalize' }}>{role}</span>
        <button onClick={logout} style={{ fontSize:12, padding:'5px 12px', border:'1px solid #ddd', borderRadius:7, background:'#fff', cursor:'pointer' }}>Logout</button>
      </div>
    </div>
  );
}